import React from "react";
var modalOverrides = {
    dismissHTML: "X",
    dismissStyle: {
        color: "#fff",
        fontSize: "25px"
    },
    style: {
        background: "#8f38de",
        color: "#fff",
        padding: "2em 3.5em",
        borderRadius: "10px",
        height: "48vh",
        width: "43%"
    }
};
var largeVideoModal = {
    dismissHTML: "X",
    dismissStyle: {
        background: "rgb(255 89 89)",
        width: "4%",
        textAlign: "center",
        borderRadius: "0px 10px 0px 10px",
        right: "0%",
        fontSize: "25px"
    },
    style: {
        overflow: "hidden",
        borderRadius: "10px",
        top: "-6.5%",
        left: "-.5%",
        aspectRatio: "16/9",
        background: "#000",
        width: "70.7%"
    }
};
var textModal = function (width, center) {
    if (width === void 0) { width = "80%"; }
    if (center === void 0) { center = false; }
    var m = {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            textAlign: center ? "center" : "left",
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            minWidth: "500px",
            width: width
        }
    };
    return m;
};
var ModalVideo = function (_a) {
    var url = _a.url;
    return React.createElement("div", { key: url, style: { width: "100%", height: "100%" } },
        React.createElement("iframe", { key: "iframe_" + url, src: "".concat(url, "&autoplay=1"), width: "100%", height: "100%", frameBorder: "0", allowFullScreen: true }));
};
export { modalOverrides, textModal, ModalVideo, largeVideoModal };
var Link = function (_a) {
    var booth = _a.booth, title = _a.title, href = _a.href, children = _a.children;
    return React.createElement("a", { key: title, href: href, target: "_blank", "data-event-category": booth, "data-event-action": "Link Click", "data-event-label": title, title: title, "aria-label": title, style: { textDecoration: "underline" }, className: "_gtm-event" }, children ? children : "Company site");
};
var images = {
    facebook: "https://assets.swoogo.com/uploads/full/2170290-6362abd788e78.png",
    twitter: "https://assets.swoogo.com/uploads/2170291-6362abd7b6739.svg",
    instagram: "https://assets.swoogo.com/uploads/full/2170294-6362abd9bd583.png",
    linkedin: "https://assets.swoogo.com/uploads/full/2170292-6362abd7b663c.png",
    youtube: "https://assets.swoogo.com/uploads/2170395-6362b2c5ce2cb.svg"
};
var imageCss = {
    width: "60px",
    height: "auto",
    margin: "0 10px"
};
export var sponsorModal = function (booth, name, text, links) {
    if (text === void 0) { text = ""; }
    var socialMedia = Object.keys(links).filter(function (x) { return x !== "company"; }).map(function (key) {
        return React.createElement(Link, { booth: booth, title: name, href: links[key] },
            React.createElement("img", { style: imageCss, src: images[key] }));
    });
    return React.createElement("div", { style: { height: "100%", width: "100%", textAlign: "center", fontWeight: "bold" } },
        text,
        links.company ? React.createElement("p", null,
            React.createElement(Link, { booth: booth, title: name, href: links.company })) : null,
        socialMedia.length > 0 ? socialMedia : null,
        links.contactUs ? React.createElement("p", null,
            React.createElement(Link, { booth: booth, title: name, href: links.contactUs }, "Contact Us")) : null);
};
